export default __webpack_public_path__ + "static/media/timw.d8f1826f.svg";